<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline' :onFinish='pageSearchChange'>
    <a-form-item label="模板名称" name='keyword'>
      <a-input v-model:value="search.keyword" style="width: 300px;" placeholder="请输入模版名称进行搜索" />
    </a-form-item>
    <a-form-item label="提交时间" name='time'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='data'>
    <template v-slot:audit="{ record }">
      <p v-if='record.audit == -1'>提交异常</p>
      <p v-if='record.audit == 0'>未提交</p>
      <p v-if='record.audit == 1'>审核中</p>
      <p v-if='record.audit == 2'>已通过</p>
      <p v-if='record.audit == 3'>已拒绝</p>
    </template>
    <template v-slot:update_time="{ record }">
      <p>{{record.audit == 1?'-':record.update_time}}</p>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { reactive, ref, } from "vue";
  import { getSmsAuditList } from "@/api/message";
  import { iscode } from "@/utils/app";
  const def = {
    page: 1,
    limit: 10,
    start_time:'',
    end_time:'',
    keyword:''
  };
  export default {
    setup(props) {
      let columns = [
        {
          title: "模板名称",
          dataIndex: "name",
          width: 120,
          ellipsis: true,
        },
        {
          title: "内容",
          dataIndex: "content",
          width: 350,
          ellipsis: true,
        },
        {
          title: "提交日期",
          dataIndex: "create_time",
          width: 160,
        },
        {
          title: "审核日期",
          key: "update_time",
          slots: { customRender: "update_time" },
          width: 160
        },
        {
          title: "审核结果",
          key: "audit",
          slots: { customRender: "audit" },
          width: 100
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 350,
          ellipsis: true,
        },
      ];

      const search = ref({ ...def });
      const listLoading = ref(false);
      const total = ref(0);
      const data = ref([]);
      const time = ref([]);
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
        initData(search.value)
      }
      const initData = async (values) => {
        listLoading.value = true;
        let res = await getSmsAuditList(values).then((res) => res.data);
        listLoading.value = false;
        data.value = res.data.data;
        total.value = res.data.total;
      };
      initData(search.value);
      return {
        columns,
        search,
        listLoading,
        total,
        data,
        pageCurrentChange,
        pageSizeChange,
        pageSearchChange,
        time,
        onChange
      }
    }
  }
</script>